import type { Payout } from '@packages/domain/models/payout';
import { SET_PAYOUTS } from 'constants/payouts';

export const setPayouts = (payouts: Payout[]) => ({
  type: SET_PAYOUTS,
  payload: payouts,
});
